<!--
Voting college selection screen
@author ab557z
-->
<template>
  <div id="contain" class="container">
  <Nav name="Select a College" />
  <div class="vContainer">
      <p style="margin-top:16px" class="votingInstructions">Colleges listed are not necessarily contested at every election.
      Once made, your selection cannot be changed until the next election year.</p>
      <ul class="list-group">
        <li v-for="value in values" :key="value.ouCode" @click="saveChoice(value.ouCode)" style="margin-bottom:10px;" class="list-group-item electionLink">
          <font-awesome-icon style="margin-top:6px;" icon="arrow-right" size="sm" class="menuChev"></font-awesome-icon>
          <b>{{value.name}}</b>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'VotingCollege',
  data () {
    return {
      values: {}
    }
  },

  mounted () {
    // Fetch the sms setting from the the server. There are only 2 editable setting right now. DOESNT WORK
    axios.get('/vote/rest/college')
      .then(response => {
        this.values = {}
        this.values = response.data
      })
  },
  methods: {
    // Saves setting change back to server
    saveChoice (college) {
      axios.post('/vote/rest/college/save?collegeId=' + college)
        .then(response => {
          if (response.data == 'OK') {
            this.$router.push('/voting/school')
          } else {
            this.alert(response.data,
              () => {
                this.$router.push('/')
              })
          }
        })
    }
  }
}
</script>
